export default {
  bases: ['/dashboard'],
  fetches: [],
  build: () => []
}
